export default [
  {
    path: '/previous-video',
    name: 'previous-video',
    component: resolve => require(['views/previous-video'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/live-list',
    name: 'live-list',
    component: resolve => require(['views/live-list'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/previous-video/previous-video-form/:isEdit/:id',
    name: 'previous-video-form',
    props: true,
    component: resolve => require(['views/previous-video-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '往期视频/视频', isForm: true }
  },
  {
    path: '/previous-video-detail/:id',
    name: 'previous-video-detail',
    component: resolve => require(['views/previous-video-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '往期视频/视频详情' }
  },
  {
    path: '/live-list/live-list-form/:isEdit/:id',
    name: 'live-list-form',
    props: true,
    component: resolve => require(['views/live-list-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '直播列表/直播', isForm: true }
  },
  {
    path: '/live-list-detail/:id',
    name: 'live-list-detail',
    component: resolve => require(['views/live-list-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '直播列表/直播详情' }
  },
  {
    path: '/previous-video-audit/:status',
    name: 'previous-video-audit',
    component: resolve => require(['views/previous-video-audit'], resolve),
    meta: { auth: true, view: 'pc' }
  }
]
